import { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import projectsData from '../data/projectsData';
import ProjectCard from '../components/projectCard';
import ProjectPopup from '../components/projectPopup';

const ProjectsPage = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleCardClick = (project) => {
        setSelectedProject(project);
        setPopupOpen(true);
    };

    const handleClosePopup = () => {
        setPopupOpen(false);
        setSelectedProject(null);
    };

    const getDataForTab = () => {
        switch (selectedTab) {
            case 0:
                return projectsData.all;
            case 1:
                return projectsData.softwareDevelopment;
            case 2:
                return projectsData.AIML;
            default:
                return projectsData.all;
        }
    };

    return (
        <Box
            sx={{
                backgroundImage: 'linear-gradient(to bottom, #120222, #095c79)',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: { xs: 2, sm: 4 },
            }}
        >
            {/* <Stack spacing={4} sx={{ maxWidth: { xs: 360, sm: 600, md: 800, lg: 1000 }, textAlign: 'center' }}> */}
            <Stack spacing={4} sx={{ textAlign: 'center' }}>
                <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'white', fontSize: { xs: '2rem', sm: '2.5rem' } }}>
                    My Work
                </Typography>
                <Typography variant="h6" sx={{ color: '#B0BEC5', fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                    A showcase of my work, including web applications, software solutions, and more.
                </Typography>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
                    <Tabs
                        value={selectedTab}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        textColor="inherit"
                        indicatorColor="primary"
                        centered={false}
                    >
                        <Tab sx={{ color: '#B0BEC5' }} label="All Projects" />
                        <Tab sx={{ color: '#B0BEC5' }} label="Software Development" />
                        <Tab sx={{ color: '#B0BEC5' }} label="AI/ML" />
                    </Tabs>
                </Box>

                <Stack spacing={5} sx={{ width: '100%' }}>
                    {getDataForTab().map((project, index) => (
                        <ProjectCard
                            key={index}
                            title={project.title}
                            description={project.description}
                            image={project.image}
                            highlights={project.highlights}
                            skills={project.skills}
                            slideDirection={index % 2 === 0 ? 'left' : 'right'}
                            onCardClick={() => handleCardClick(project)}
                        />
                    ))}
                </Stack>
            </Stack>

            {selectedProject && (
                <ProjectPopup
                    open={popupOpen}
                    onClose={handleClosePopup}
                    project={selectedProject}
                />
            )}
        </Box>
    );
};

export default ProjectsPage;